import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Navbar from './Navbar';
import Footer from './Footer';
import { submitContactForm, getWebsiteTexts } from '../firebase/services';
import dashboardImage from '../assets/images/dashboard.png';
import dashboardImage2 from '../assets/images/dashboard2.png';
import mobileDashboardImage from '../assets/images/mobile-dashboard.png';
import mobileDashboardImage2 from '../assets/images/mobile-dashboard2.png';
import mobileDashboardImage3 from '../assets/images/mobile-dashboard3.png';
import founder1 from '../assets/images/efe-image.JPG';
import founder2 from '../assets/images/sam-image3.png';
import founder3 from '../assets/images/omer-image.jpeg';
import statIcon from '../assets/images/stat-icon.png';
import scheduleIcon from '../assets/images/schedule-icon.png';
import notificationIcon from '../assets/images/notification-icon.png';
import peopleIcon from '../assets/images/people-icon.png';

const LandingPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        email: '',
        company: '',
        message: ''
    });
    const [formStatus, setFormStatus] = useState({
        submitting: false,
        submitted: false,
        error: null
    });
    const [websiteTexts, setWebsiteTexts] = useState({});

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validate form data
        if (!formData.name || !formData.email || !formData.company || !formData.surname) {
            setFormStatus({
                submitting: false,
                submitted: false,
                error: "Please fill in at least your name, email, company and surname."
            });
            return;
        }
        
        try {
            setFormStatus({
                submitting: true,
                submitted: false,
                error: null
            });
            
            // Submit form data to Firebase
            const result = await submitContactForm(formData);
            
            if (result.success) {
                // Reset form on success
                setFormData({
                    name: '',
                    surname: '',
                    email: '',
                    company: '',
                    message: ''
                });
                
                setFormStatus({
                    submitting: false,
                    submitted: true,
                    error: null
                });
            } else {
                throw new Error(result.error || "Failed to submit form");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            setFormStatus({
                submitting: false,
                submitted: false,
                error: error.message
            });
        }
    }

    const getWebsiteTextsFunc = async () => {
      try {
        const texts = await getWebsiteTexts();
        setWebsiteTexts(texts[0].data);
      } catch (error) {
        console.error("Error fetching website texts:", error);
      }
    };

    useEffect(() => {
      getWebsiteTextsFunc();
    }, []);

  return (
    <StyledLandingPage>
      <Navbar />
      
      {/* Hero Section */}
      <HeroSection>
        <div className="container">
          <HeroContent>
            <h1>{websiteTexts["hero-text"]}</h1>
            <h2>{websiteTexts["hero-subtext"]}</h2>
            <p>{websiteTexts["hero-subtext2"]}</p>
            <p>{websiteTexts["hero-subtext3"]}</p>
            <GetStartedButton onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact-us').scrollIntoView({ behavior: 'smooth', block: 'start' });
            }}>
              Get Started Today <ArrowIcon>→</ArrowIcon>
            </GetStartedButton>
          </HeroContent>
        </div>
      </HeroSection>

      {/* Dashboard Image Section */}
      <DashboardImageSection>
        <div className="container">
          <DashboardImage src={dashboardImage} alt="Fleet management dashboard" />
        </div>
      </DashboardImageSection>

      {/* Features Section */}
      <FeaturesSection id="features">
        <div className="container">
          <h2>{websiteTexts["features-title1"]} <br />{websiteTexts["features-title2"]}</h2>
          <FeaturesGrid>
            <FeatureCard>
              <FeatureIcon><img className="feature-icon-one" src={statIcon} alt="statIcon" /></FeatureIcon>
              <h3>{websiteTexts["features-one-title1"]}<br />{websiteTexts["features-one-title2"]}</h3>
              <p>{websiteTexts["features-one-description"]}</p>
            </FeatureCard>
            <FeatureCard>
            <FeatureIcon><img className="feature-icon-two" src={scheduleIcon} alt="scheduleIcon" /></FeatureIcon>
              <h3>{websiteTexts["features-two-title1"]}<br />{websiteTexts["features-two-title2"]}</h3>
              <p>{websiteTexts["features-two-description"]}</p>
            </FeatureCard>
            <FeatureCard>
            <FeatureIcon><img className="feature-icon-three" src={notificationIcon} alt="notificationIcon" /></FeatureIcon>
              <h3>{websiteTexts["features-three-title1"]}<br />{websiteTexts["features-three-title2"]}</h3>
              <p>{websiteTexts["features-three-description"]}</p>
            </FeatureCard>
            <FeatureCard>
            <FeatureIcon><img className="feature-icon-four" src={peopleIcon} alt="peopleIcon" /></FeatureIcon>
              <h3>{websiteTexts["features-four-title1"]}<br />{websiteTexts["features-four-title2"]}</h3>
              <p>{websiteTexts["features-four-description"]}</p>
            </FeatureCard>
          </FeaturesGrid>
        </div>
      </FeaturesSection>

      {/* How It Works Section */}
      <HowItWorksSection id="how-it-works">
        <div className="container">
          <h2>How It Works?</h2>
          <StepsContainer>
            <Step white>
              <StepText>{websiteTexts["how-it-works-one"]}</StepText>
            </Step>
            <StepDivider>
              <ArrowDown>↓</ArrowDown>
            </StepDivider>
            <Step green>
              <StepText>{websiteTexts["how-it-works-two"]}</StepText>
            </Step>
            <StepDivider>
              <ArrowDown>↓</ArrowDown>
            </StepDivider>
            <Step white>
              <StepText>{websiteTexts["how-it-works-three"]}</StepText>
            </Step>
          </StepsContainer>
        </div>
      </HowItWorksSection>

      {/* Safety Section */}
      <SafetySection>
        <div className="container">
          <h2>{websiteTexts["safety-title"]}</h2>
          <p>{websiteTexts["safety-subtitle"]}</p>
          {/* <SafetyImagesContainer>
            <SafetyImage />
            <div>
              <SafetyImage small />
              <SafetyImage small />
            </div>
          </SafetyImagesContainer> */}
          {/* Dashboard Image Section */}
          { window.innerWidth >= 768 ? <DashboardImageSection>
            <div className="container">
              <DashboardImage2 src={dashboardImage2} alt="Fleet management dashboard" />
            </div>
          </DashboardImageSection> : null }

          { window.innerWidth < 768 ? 
          <div>
          <DashboardImageSection>
            <div className="container">
              <DashboardImage2 src={mobileDashboardImage2} alt="Fleet management dashboard" />
            </div>
          </DashboardImageSection> 
          <DashboardImageSection>
            <div className="container">
              <DashboardImage2 src={mobileDashboardImage} alt="Fleet management dashboard" />
            </div>
          </DashboardImageSection> 
          <DashboardImageSection>
            <div className="container">
              <DashboardImage2 src={mobileDashboardImage3} alt="Fleet management dashboard" />
            </div>
          </DashboardImageSection> 
          </div>
          : null }
        </div>
      </SafetySection>

      {/* CTA Section */}
      <CTASection id="contact-us">
        <div className="container">
          <h2>{websiteTexts["cta-title"]}</h2>
          <p>{websiteTexts["cta-subtitle"]}</p>
          <ContactForm onSubmit={handleSubmit}>
            {formStatus.submitted ? (
              <SuccessMessage>
                <h3>Thank you for contacting us!</h3>
                <p>We've received your message and will get back to you soon.</p>
              </SuccessMessage>
            ) : (
              <>
                <FormRow>
                  <FormGroup>
                    <label>Name *</label>
                    <input 
                      type="text" 
                      placeholder="Name" 
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })} 
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <label>Surname *</label>
                    <input 
                      type="text" 
                      placeholder="Surname" 
                      value={formData.surname}
                      onChange={(e) => setFormData({ ...formData, surname: e.target.value })}
                      required 
                    />
                  </FormGroup>
                </FormRow>
                <FormRow>
                  <FormGroup>
                    <label>Email *</label>
                    <input 
                      type="email" 
                      placeholder="Email" 
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })} 
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <label>Company *</label>
                    <input 
                      type="text" 
                      placeholder="Company" 
                      value={formData.company}
                      onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                      required 
                    />
                  </FormGroup>
                </FormRow>
                <FormGroup fullWidth>
                  <label>Message</label>
                  <textarea 
                    placeholder="Message" 
                    rows="5" 
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  ></textarea>
                </FormGroup>
                {formStatus.error && (
                  <ErrorMessage>{formStatus.error}</ErrorMessage>
                )}
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <ContactButton 
                    type="submit" 
                    disabled={formStatus.submitting}
                  >
                    {formStatus.submitting ? 'Sending...' : 'Contact Us'}
                  </ContactButton>
                </div>
              </>
            )}
          </ContactForm>
        </div>
      </CTASection>

      {/* Founders Section */}
      <FoundersSection id="founders">
        <div className="container">
          <h2>{websiteTexts["founders-title"]}</h2>
          <p>{websiteTexts["founders-subtitle1"]}<br />{websiteTexts["founders-subtitle2"]}</p>
          <FoundersGrid>
            <FounderCard>
              <FounderImageWrapper>
                <img src={founder1} alt="Efe Poyraz" />
              </FounderImageWrapper>
              <h3>Efe Poyraz</h3>
              <p className="title">Product / Business Development</p>
              <p className="bio">efe@smartestcompany.co <br /> +90 553 902 08 99</p>
            </FounderCard>
            <FounderCard>
              <FounderImageWrapper>
                <img src={founder2} alt="Samuel Karatas" />
              </FounderImageWrapper>
              <h3>Samuel Karatas</h3>
              <p className="title">Software Development</p>
              <p className="bio">samuel@smartestcompany.co <br /> +90 507 328 28 38</p>
            </FounderCard>
            <FounderCard>
              <FounderImageWrapper>
                <img src={founder3} alt="Ö. Kerem Turfan" />
              </FounderImageWrapper>
              <h3>Ö. Kerem Turfan</h3>
              <p className="title">Hardware Development</p>
              <p className="bio">kerem@smartestcompany.co <br /> +90 544 388 21 02</p>
            </FounderCard>
          </FoundersGrid>
          <MoreAboutButton onClick={() => window.open('https://smartestcompany.co/', '_blank')} className="more-about-btn">
            <div>
              <h4>More About Us</h4>
              <p>Get to know more about our mission and values.</p>
            </div>
            <ArrowIcon className="right-arrow">→</ArrowIcon>
          </MoreAboutButton>
        </div>
      </FoundersSection>

      <Footer />
    </StyledLandingPage>
  );
};

// Styled Components
const StyledLandingPage = styled.div`
  background-image: linear-gradient(to bottom, #f8f9f8 7%, rgba(0, 250, 154, 0.3) 25%, #f8f9f8 40%, #f8f8f8 47%,  rgba(0, 250, 154, 0.3) 65%, #f8f9f8 90%, #f8f8f8 100%);
  
`;

const HeroSection = styled.section`
//   background-color: #e6f9f3;
  padding: 80px 0;
  
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    text-align: center;
  }
`;

const HeroContent = styled.div`
  max-width: 100%;
  margin: 0 auto;
  
  h1 {
    font-size: 68px;
    font-weight: 500;
    // margin-bottom: 10px;
    color: #222;
  }
  
  h2 {
    font-size: 25px;
    font-weight: 400;
    margin-bottom: 30px;
    color: #222;
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
  }
  
  p {
    font-size: 16px;
    // margin-bottom: 10px;
    line-height: 1.6;
    color: rgba(34, 34, 34, 0.5);
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 42px;
    }
    h2 {
      font-size: 16px;
    }
    p {
      font-size: 11px;
    }
  }
`;

const GetStartedButton = styled.button`
  background-color: #00Fa9a;
  color: #222;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 400;
  padding: 15px 35px;
  margin-top: 30px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: #00d68f;
  }
`;

const ArrowIcon = styled.span`
  margin-left: 8px;
  font-size: 16px;
  font-weight: 400;
`;

// const HeroImagePlaceholder = styled.div`
//   width: 500px;
//   height: 300px;
//   background-color: #ddd;
//   border-radius: 10px;
//   border: 2px solid #ccc;
// `;

const DashboardImageSection = styled.section`
  padding: 0 0 40px;
//   background-color: #e6f9f3;
  text-align: center;
  
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }
`;

const DashboardImage = styled.img`
  max-width: 100%;
  height: auto;
  border-radius: 20px;
`;

const DashboardImage2 = styled.img`
  max-width: 100%;
  height: auto;
`;

const FeaturesSection = styled.section`
  padding: 80px 0;
//   background-color: #e6f9f3;
  
  h2 {
    font-size: 56px;
    font-weight: 500;
    margin-bottom: 50px;
    text-align: left;
    color: #222;
    line-height: 1.2;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 38px;
    }
  }
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureCard = styled.div`
  background-color: #fff;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  
  h3 {
    font-size: 22px;
    font-weight: 500;
    margin: 15px 0 10px;
    color: #222;
    line-height: 1.3;
  }
  
  p {
    color: #555;
    line-height: 1.5;
    font-size: 15px;
  }
`;

const FeatureIcon = styled.div`
  .feature-icon-one {
    width: 44px;
    height: 34px;
  }
  .feature-icon-two {
    width: 42px;
    height: 42px;
  } 
  .feature-icon-three {
    width: 42px;
    height: 42px;
  } 
  .feature-icon-four {
    width: 49px;
    height: 29px;
  } 
`;

const HowItWorksSection = styled.section`
  padding: 80px 0;
//   background-color: #f9f9f9;
  text-align: center;
  
  h2 {
    font-size: 56px;
    font-weight: 500;
    margin-bottom: 60px;
    color: #222;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 38px;
    }
  }
`;

const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 800px;
  margin: 0 auto;
`;

const Step = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 700px;
  height: 80px;
  border-radius: 40px;
  background-color: ${props => props.green ? '#00Fa9a' : '#ffffff'};
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  margin: 10px 0;
`;

const StepText = styled.p`
  margin: 0;
  font-size: 22px;
  font-weight: 500;
  color: #222;
  text-align: center;
  padding: 0 20px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const StepDivider = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ArrowDown = styled.div`
  font-size: 24px;
  color: #666;
`;

const SafetySection = styled.section`
  padding: 80px 0;
  text-align: center;
  
  h2 {
    font-size: 56px;
    font-weight: 500;
    margin-bottom: 10px;
    color: #222;
  }
  
  p {
    font-size: 20px;
    font-weight: 500;
    max-width: 800px;
    margin: 0 auto 50px;
    color: #222;
    line-height: 1.3;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 38px;
    }

    p {
      font-size: 16px;
    }
  }
`;

const CTASection = styled.section`
  padding: 80px 0;
//   background-color: #e6f9f3;
  text-align: center;
  
  h2 {
    font-size: 56px;
    font-weight: 500;
    margin-bottom: 10px;
    color: #222;
  }
  
  p {
    font-size: 20px;
    font-weight: 500;
    max-width: 800px;
    margin: 0 auto 50px;
    color: #222;
    line-height: 1.3;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 38px;
    }

    p {
      font-size: 16px;
    }
  }
`;

const ContactForm = styled.form`
  max-width: 600px;
  margin: 0 auto;
  background-color: #fff;
  padding: 40px;
  border-radius: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  text-align: left;
`;

const FormRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0;
  }
`;

const FormGroup = styled.div`
  flex: 1;
  margin-bottom: 20px;
  width: ${props => props.fullWidth ? '100%' : 'auto'};
  
  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
  }
  
  input, textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 16px;
    
    &:focus {
      outline: none;
      border-color: #00Fa9a;
    }
  }
  
  textarea {
    resize: vertical;
  }
`;

const ContactButton = styled.button`
  background-color: #00Fa9a;
  color: #222;
  border: none;
  border-radius: 30px;
  padding: 15px 40px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 20px;
  transition: all 0.3s ease;
  margin-left: auto;
  margin-right: auto;
  
  &:hover {
    background-color: #00d68f;
    transform: translateY(-2px);
  }
  
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const SuccessMessage = styled.div`
  background-color: rgba(0, 250, 154, 0.1);
  border: 1px solid #00Fa9a;
  border-radius: 10px;
  padding: 30px;
  text-align: center;
  margin: 20px 0;
  
  h3 {
    color: #222;
    font-size: 24px;
    margin-bottom: 15px;
  }
  
  p {
    color: #222;
    font-size: 16px;
  }
`;

const ErrorMessage = styled.div`
  background-color: rgba(255, 99, 71, 0.1);
  border: 1px solid #ff6347;
  border-radius: 5px;
  color: #ff6347;
  padding: 10px 15px;
  margin: 10px 0;
  font-size: 14px;
  text-align: center;
`;

const FoundersSection = styled.section`
  padding: 80px 0;
  text-align: center;
//   background-color: #f9f9f9;
  
  h2 {
    font-size: 42px;
    font-weight: 700;
    margin-bottom: 15px;
    color: #333;
  }
  
  p {
    margin-bottom: 60px;
    color: #555;
    font-size: 16px;
    line-height: 1.6;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const FoundersGrid = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  max-width: 1000px;
  margin: 0 auto 40px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const FounderCard = styled.div`
  text-align: center;
  background-color: #fff;
  border-radius: 20px;
  padding: 30px 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 300px;
  
  h3 {
    font-size: 20px;
    font-weight: 600;
    margin: 15px 0 5px;
    color: #333;
  }
  
  p.title {
    color: #666;
    font-size: 14px;
    margin-bottom: 15px;
  }
  
  p.bio {
    color: #777;
    font-size: 14px;
    line-height: 1.5;
  }
`;

const FounderImageWrapper = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin: 0 auto 15px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const MoreAboutButton = styled.button`
  background-color: #00Fa9a;
  color: #333;
  border: none;
  border-radius: 40px;
  padding: 15px 30px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 500px;
  margin: 0 auto;
  text-align: left;
  
  div {
    display: flex;
    flex-direction: column;
  }
  
  h4 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 5px 0;
  }
  
  p {
    margin: 0;
    font-size: 12px;
    opacity: 0.8;
  }
  
  .right-arrow {
    font-size: 20px;
    margin-left: 20px;
  }
  
  &:hover {
    background-color: #00e38c;
    transform: translateY(-2px);
  }
`;

export default LandingPage;
